<div #root class="detail-panel">
    <div class="detail-panel__body">
        <div class="row g-2 mt-3">
            <div class="col">
                <p class="title">Información detallada del reporte</p>
            </div>
        </div>
        <div class="row" *ngIf="data?.required_supplier">
            <div class="col">
                <p><span class="text-label">Nombre del taller: </span>{{data?.supplier?.supplier?.name}}</p>
            </div>
            <div class="col" *ngIf="role === 'Administrativo'">
                <p><span class="text-label">Numero de cuenta: </span>{{data?.supplier?.supplier?.account_number |
                    maskCard}}</p>
            </div>
            <div class="col" *ngIf="role === 'Administrador' || role === 'Supervisor de mantenimiento'">
                <p><span class="text-label">Tipo de reparación: </span>{{data?.maintenance_type?.name}}</p>
            </div>
            <div class="col" *ngIf="role === 'Administrador' || role === 'Supervisor de mantenimiento'">
                <p><span class="text-label">Estado administrativo: </span>{{data?.administrative_status?.name || 'N/A'}}
                </p>
            </div>
            <div class="col" *ngIf="(role == 'Administrador' || role === 'Supervisor de mantenimiento') && data?.administrative_status?.name === 'Pagado'">
                <p><span class="text-label">Factura de pago: </span><a role="button" class="link"
                        (click)="uploadFilePaymentInvoice(data)">Subir factura de pago</a></p>
            </div>
            <div class="col">
                <p><span class="text-label">Evidencias: </span><a role="button" class="link"
                        (click)="openModalEvidences(data)">Ver evidencias</a></p>
            </div>
            <div class="col"></div>
        </div>
        <div class="row" *ngIf="data?.required_supplier">
            <div class="col-lg-4">
                <p class="text-wrap"><span class="text-label">Ubicación del taller:
                    </span>{{data?.supplier?.supplier?.direction_address}}</p>
            </div>
            <div class="col">
                <p><span class="text-label ">Costo: </span>{{data?.supplier?.cost | currency}}</p>
            </div>
            <div class="col">&nbsp;</div>
            <div class="col">&nbsp;</div>
        </div>
        <div class="row" *ngIf="!data?.required_supplier">
            <div class="col">
                <p><span class="text-label">Tipo de reparación: </span>{{data?.maintenance_type?.name}}</p>
            </div>
            <div class="col">
                <p><span class="text-label">Costo: </span>{{totalCost | currency}}</p>
            </div>
            <div class="col">
                <p><span class="text-label">Evidencias: </span> <a role="button" class="link"
                        (click)="openModalEvidences(data)">Ver evidencias</a></p>
            </div>
            <div class="col">&nbsp;</div>
        </div>
    </div>
</div>